import { PageNames } from '@/constants';
import { AntennaIcon } from '@/icons/AntennaIcon.tsx';
import { DeadFishIcon } from '@/icons/DeadFishIcon.tsx';
import { Icon } from '@/utils';

import { OrbitOneNavIcon } from './OrbitOneNavIcon.tsx';

export const getIconByName = (name: PageNames | undefined) => {
  switch (name) {
    //Top level items
    case PageNames.Dashboard:
      return Icon.LayoutDashboard;
    case PageNames.Layouts:
      return Icon.Grid3x3;
    //Main items
    case PageNames.BargeControl:
      return Icon.Barge;
    case PageNames.CameraCheck:
      return Icon.MonitorPlay;
    case PageNames.HybridPower:
      return Icon.BatteryFull;
    case PageNames.UpCycle:
      return DeadFishIcon;
    case PageNames.OrbitOne:
      return OrbitOneNavIcon;
    case PageNames.PenViewer:
      return Icon.Unit;

    //Footer items
    case PageNames.Automation:
      return Icon.WandSparkles;
    case PageNames.DeviceConfig:
      return Icon.MonitorSmartphone;
    case PageNames.EventStream:
      return Icon.WavesHorizontal;
    case PageNames.Inventory:
      return Icon.Package;
    case PageNames.Settings:
      return Icon.Settings;
    case PageNames.NetworkHealth:
      return AntennaIcon;
    case PageNames.SiteSetup:
      return Icon.MapPin;
    default:
      return Icon.Circle;
  }
};
